import React from 'react';
import {
  useUpdateSalesforceLeadFieldValueMutation,
  SalesforceLeadField,
  SalesforceLead,
} from 'api';

interface Props {
  field: SalesforceLeadField;
  salesforceLead: SalesforceLead;
}

const Name = ({field, salesforceLead}: Props) => {
  const value = salesforceLead.addition[`${field.fieldName}`];
  const [lastName, firstName] = value.split(' ');
  const [errorMessage, setErrorMessage] = React.useState('');
  const [updateFieldValue] = useUpdateSalesforceLeadFieldValueMutation({
    onCompleted: (data) => {
      setErrorMessage(data.updateSalesforceLeadFieldValue.error);
    },
  });

  return (
    <>
      <input
        defaultValue={lastName}
        className="w-max"
        onBlur={(e) => {
          updateFieldValue({
            variables: {
              salesforceLeadId: salesforceLead.id,
              attributes: {fieldName: 'lastName', value: e.target.value},
            },
          });
        }}
      />
      <input
        defaultValue={firstName}
        className="w-max"
        onBlur={(e) => {
          updateFieldValue({
            variables: {
              salesforceLeadId: salesforceLead.id,
              attributes: {fieldName: 'firstName', value: e.target.value},
            },
          });
        }}
      />
      {errorMessage && <p className="text-red-500">{errorMessage}</p>}
    </>
  );
};

export default Name;
